<template>
  <template v-if="items && items.length > 0">
    <TGrid :gap-y="4">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="text-left"
        :class="colClasses"
      >
        <ULink class="text-sm" :href="item.href" external>
          {{ item.name }}
        </ULink>
      </div>
    </TGrid>
  </template>
</template>

<script setup lang="ts">
export type SLinksItemType = {
  name: string
  href: string
}

export interface propsInterface {
  items: Array<SLinksItemType>
  col?: number
}

const props = withDefaults(defineProps<propsInterface>(), {
  col: 4,
})

const colClasses = computed(() => {
  switch (props.col) {
    case 1:
      return 'col-span-12 md:col-span-12 lg:col-span-12'
    case 2:
      return 'col-span-12 md:col-span-6 lg:col-span-6'
    case 3:
      return 'col-span-12 md:col-span-6 lg:col-span-4'
    case 4:
    default:
      return 'col-span-12 md:col-span-6 lg:col-span-3'
  }
})
</script>
